import { Box, Chip, MenuItem, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import ActionButton from 'src/components/ActionButton';
import { capitalize } from 'src/utils/string';
import { Edit as EditIcon } from '@mui/icons-material';
import { WrappedStructureDefinition } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/StructureDefinition';

type Props = {
  row: WrappedStructureDefinition;
  handler: Function;
};

export default function CustomFieldsRow({ row, handler }: Props) {
  const { name, version, description, context, status } = row;

  const organizationName = row?.getOrganizationName();

  const isRetired = Boolean(status === 'retired');

  return (
    <TableRow>
      <TableCell>
        <Typography variant="subtitle2">{name}</Typography>
        <Tooltip title="Version" placement="bottom">
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {version}
          </Typography>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{organizationName}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{description}</Typography>
      </TableCell>
      <TableCell>
        {context?.map((e) => (
          <Typography variant="body2" key={e?.expression}>
            {e?.expression}
          </Typography>
        ))}
      </TableCell>
      <TableCell>
        <Chip size="small" label={capitalize(status)} color={isRetired ? 'error' : 'default'} />
      </TableCell>
      <TableCell align="right">
        <ActionButton
          renderChildren={(isMenuOpen, setIsMenuOpen) => (
            <Box>
              <div tabIndex={1}>
                <MenuItem
                  sx={{ paddingX: 3 }}
                  onClick={() => {
                    setIsMenuOpen(false);
                    handler();
                  }}
                >
                  <Box display={'flex'}>
                    <EditIcon htmlColor="#00ab55" />
                    <Typography textAlign={'left'} px={'8px'}>
                      Edit
                    </Typography>
                  </Box>
                </MenuItem>
              </div>
            </Box>
          )}
        />
      </TableCell>
    </TableRow>
  );
}
